(function () {
  function closeSizeChart() {
    var chart = document.querySelector('.size_chart');
    var dialog = document.querySelector('.size_dec');

    if (dialog) dialog.classList.remove('itg_overlay');
    if (chart) chart.classList.remove('chart_open');
    document.body.classList.remove('itg_custom');
  }

  function initializeProductTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.product-description-tabs-nav-item'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('.product-description-tabs-body-item'));

    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panelId = tab.getAttribute('data-id');

        tabs.forEach(function (item) {
          item.classList.toggle('active', item === tab);
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('active', panel.getAttribute('data-id') === panelId);
        });
      });
    });
  }

  function initializeProductControls() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('.size_head')) {
        var chart = document.querySelector('.size_chart');
        if (chart) chart.classList.add('chart_open');
        document.body.classList.add('itg_custom');
        return;
      }

      if (event.target.closest('.size_icon')) {
        closeSizeChart();
        return;
      }

      var dialog = document.querySelector('.size_dec');
      var openChart = document.querySelector('.size_chart.chart_open');
      if (openChart && dialog && !dialog.contains(event.target)) closeSizeChart();
    });

    document.addEventListener('mouseover', function (event) {
      var swatch = event.target.closest('.variant-swatch__item, .block-swatch__item');
      if (!swatch) return;

      var option = swatch.closest('.product-form__option');
      if (!option) return;

      var selector = swatch.classList.contains('variant-swatch__item') ? '.itg_Color' : '.itg_Size';
      var label = option.querySelector(selector);
      if (label) label.textContent = swatch.getAttribute('title') || '';
    });
  }

  function boot() {
    initializeProductTabs();
    initializeProductControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
